import { useEffect, useState } from 'react';
import { getBCConfig } from '../../api/config';

export const useGetBCConfig = () => {
  const [config, setConfig] = useState<boolean | null>(null);
  const [isBCConfigLoaded, setIsBCConfigLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setIsBCConfigLoaded(false);
        const response = await getBCConfig();

        setConfig(response);
        setIsBCConfigLoaded(true);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  return {
    config,
    isBCConfigLoaded
  };
};
